module.exports = __webpack_public_path__ + "img/ic-phone.81be8e5b.svg";